import { TOAST_DURATION } from '@/constants'
import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { mapGetters } from 'vuex'

export default {
  name: 'FertilizerList',
  components: {
    LayoutBasic
  },
  data () {
    return {
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 25
    }
  },
  computed: {
    ...mapGetters([
      'fertilizerItemsList'
    ])
  },
  methods: {
    deleteFertilizerItem (id) {
      const jsConn = new JSConn()
      jsConn.toRoutePath = '/fertilizers'
      jsConn.formParams = {
        id: id
      }
      this.$store.dispatch('deleteFertilizerItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-warning',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
